export default __webpack_public_path__ + "static/media/lackier_start.95dd9a21.png";